import { Action, handleActions } from 'redux-actions'
import { importUsers, importUsersSuccess, importUsersFail, clearImportUsersResult } from './ImportUsersAdminActions'

export interface ImportResult {
  totalRows: number
  created: number
  updated: number
  skipped: number
  errors: { row: number; message: string }[]
}

class State {
  uploading: boolean = false
  result: ImportResult | null = null
}

export const importUsersAdmin = handleActions<State, any>(
  {
    [String(importUsers)]: (state: State): State => ({
      ...state,
      uploading: true,
      result: null,
    }),
    [String(importUsersSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      uploading: false,
      result: action.payload,
    }),
    [String(importUsersFail)]: (state: State): State => ({
      ...state,
      uploading: false,
    }),
    [String(clearImportUsersResult)]: (state: State): State => ({
      ...state,
      result: null,
    }),
  },
  new State(),
)

export { State as ImportUsersAdminState }
